<a [href]="bookmark.url" target="_blank" class="bookmark-tile">
    <div class="tile-icon" *ngIf="!faviconError">
        <img [src]="tileIconSrc" alt="" (error)="faviconError=true">
    </div>
    <div class="tile-icon fallback" *ngIf="faviconError">
        {{ bookmark.name.toUpperCase()[0] }}
    </div>
    
    <p class="tile-text">{{ bookmark.name }}</p>
</a>